import { Loading, LoadingAppearance } from "../Loading";

import * as css from "./MainLoading.module.css";

export type IMainLoading = {
    className?: string;
};

const MainLoading = ({ className }: { className?: string }) => (
    <div className={`${css.mainLoadingComponent} ${className}`}>
        <Loading appearance={LoadingAppearance.Big} />
    </div>
);

export default MainLoading;
